import { UiConfig } from '../../types/config';
import { getUiConfigFilename } from '../utils/filename';
import { UI_CONFIG_DIRECTORY } from '../utils/paths';

export const fetchUiConfig = async (uiConfigName: string): Promise<UiConfig> => {
  if (!uiConfigName) {
    throw new Error('UI Config name is required');
  }

  let uiConfigJson: string;
  try {
    const filename = getUiConfigFilename(uiConfigName);
    const pathToFile = `/${UI_CONFIG_DIRECTORY}/${filename}`;
    const response = await fetch(pathToFile);
    uiConfigJson = await response.text();
  } catch (error) {
    throw new Error('Error fetching UI Config JSON');
  }

  let parsedUiConfig: UiConfig | undefined;
  try {
    parsedUiConfig = JSON.parse(uiConfigJson);
    if (!parsedUiConfig) {
      throw new Error('Error parsing UI Config JSON');
    }
  } catch (error) {
    throw new Error('Error parsing UI Config JSON');
  }

  return parsedUiConfig;
};
